import React, { useState, useEffect, forwardRef } from 'react';
import { getBatchEditValue } from '../helpers';
import { Input } from '../components';
import { useMessage } from '../hooks';

const _AddAttributeUnitForm = (
  { mode, data, submitForm, loading, setLoading, formErrors = {} },
  ref
) => {
  const initialFormState = {
    attribute_unit_id: null,
    attribute_unit_name: '',
    attribute_unit_code: '',
  };

  const initialBatchEditItems = {};

  const [formData, setFormData] = useState(initialFormState);
  const [batchEdit, setBatchEdit] = useState(false);
  const [batchEditItems, setBatchEditItems] = useState(initialBatchEditItems);
  const { hideMessage } = useMessage();

  useEffect(() => {
    setBatchEdit(false);
    if (data.length === 1) {
      setFormData({
        attribute_unit_id: data[0].attribute_unit_id,
        attribute_unit_name: data[0].attribute_unit_name || '',
        attribute_unit_code: data[0].attribute_unit_code || '',
      });
    } else if (data.length > 1 && mode !== 'add') {
      setBatchEdit(true);

      setFormData({});
      //} else if(mode === 'add') {
    } else {
      resetForm();
    }
  }, [mode, data]);

  const handleInputChange = (event, formPart) => {
    let { name, value } = event.target;

    // If input element is a checkbox, we cannot use "value"
    if (event.target.type === 'checkbox') {
      value = event.target.checked;
    }

    switch (formPart) {
      case 'batch':
        setBatchEditItems({ ...batchEditItems, [name]: value });
        break;
      default:
        setFormData({ ...formData, [name]: value });
    }

    // Hide errors on input change
    if (formErrors && formErrors[name]) {
      delete formErrors[name];
      hideMessage();
    }
  };

  const onSubmit = event => {
    event.preventDefault();

    setLoading(true);

    // Form validation
    //if (!formData.user_fullname || !formData.user_username) return

    let dataToSubmit;

    if (batchEdit) {
      let key = '';
      let tmp = {};
      const objects = Object.entries(batchEditItems);

      for (let i = 0; i < objects.length; i++) {
        if (objects[i][1]) {
          key = objects[i][0].replace('batch_', '');
          tmp = { ...tmp, [key]: formData[key] };
        }
      }

      dataToSubmit = data.map(item => {
        return {
          attribute_unit_id: item.attribute_unit_id,
          attribute_unit_name: item.attribute_unit_name,
          attribute_unit_code: item.attribute_unit_code,
          ...tmp,
        };
      });
    } else {
      dataToSubmit = formData;
    }

    // submit form
    submitForm(dataToSubmit)
      .then(() => resetForm())
      .catch(() => {
        // Errors handled in submitForm function
      })
      .finally(() => setLoading(false));
  };

  const resetForm = () => {
    setBatchEdit(false);
    setBatchEditItems(initialBatchEditItems);
    setFormData(prevFormData => {
      return { ...initialFormState };
    });
  };
  return (
    <div className="form">
      <form onSubmit={onSubmit} ref={ref}>
        {!batchEdit && (
          <div className="form-block vertical">
            <Input
              type="text"
              name="attribute_unit_name"
              value={formData.attribute_unit_name}
              onChange={handleInputChange}
              disabled={loading}
              validation={
                formErrors.attribute_unit_name
                  ? { valid: false, message: formErrors.attribute_unit_name }
                  : undefined
              }
            />
          </div>
        )}
        {!batchEdit && (
          <div className="form-block vertical">
            <Input
              type="text"
              name="attribute_unit_code"
              value={formData.attribute_unit_code}
              onChange={handleInputChange}
              disabled={loading}
              validation={
                formErrors.attribute_unit_code
                  ? { valid: false, message: formErrors.attribute_unit_code }
                  : undefined
              }
            />
          </div>
        )}
      </form>
    </div>
  );
};

export const AddAttributeUnitForm = forwardRef(_AddAttributeUnitForm);
